import { render, staticRenderFns } from "./RecordDetails.vue?vue&type=template&id=76582138&scoped=true"
import script from "./RecordDetails.vue?vue&type=script&lang=js"
export * from "./RecordDetails.vue?vue&type=script&lang=js"
import style0 from "./RecordDetails.vue?vue&type=style&index=0&id=76582138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76582138",
  null
  
)

export default component.exports